import { forwardRef, ReactNode } from "react";
import { css } from "@emotion/react";

type Props = {
    children: ReactNode,
    showOptionsHandler: () => void,
};

const DropdownPlaceholderContainer = forwardRef<HTMLDivElement, Props>(({
    children,
    showOptionsHandler,
}, ref) => {
    const style = css`
        display: flex;
        justify-content: end;
        align-items: center;
        height: 100%;
    `;

    return (
        <div css={style} onClick={showOptionsHandler} ref={ref}>
            {children}
        </div>
    );
});

DropdownPlaceholderContainer.displayName = "DropdownPlaceholderContainer";

export default DropdownPlaceholderContainer;